import { Box, Checkbox, Stack, Typography } from '@mui/material';

export function ThermsAndConditionsUs({ generelThermsAccepted, setGeneralConditions, privacyPolicyAccepted, setPrivacyPolicy, dataProcessingAggreementAccepted, setDataProcessing }) {
  return (
    <Stack direction="column" spacing={1}>
      <Stack direction="row" spacing={1}>
        <Checkbox checked={generelThermsAccepted} onChange={(e) => setGeneralConditions(e.target.checked)} />
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography>I've read the</Typography>
          <a href="https://api.fastai.tech/agreements/general_terms_2023-11-01.pdf" target="_blank" rel="noreferrer">
            <Typography sx={{ paddingLeft: '5px', paddingRight: '5px' }}>General Terms and Conditions</Typography>
          </a>
          <Typography>and I accept.</Typography>
        </Box>
      </Stack>
      <Stack direction="row" spacing={1}>
        <Checkbox checked={privacyPolicyAccepted} onChange={(e) => setPrivacyPolicy(e.target.checked)} />
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography>I've read the </Typography>
          <a href="https://api.fastai.tech/agreements/privacy_2023-11-01.pdf" target="_blank" rel="noreferrer">
            <Typography sx={{ paddingLeft: '5px', paddingRight: '5px' }}>Privacy Policy</Typography>
          </a>
          <Typography>and I accept.</Typography>
        </Box>
      </Stack>
      <Stack direction="row" spacing={1}>
        <Checkbox checked={dataProcessingAggreementAccepted} onChange={(e) => setDataProcessing(e.target.checked)} />
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography>I've read the </Typography>
          <a href="https://api.fastai.tech/agreements/data_processing_aggreement_latest.pdf" target="_blank" rel="noreferrer">
            <Typography sx={{ paddingLeft: '5px', paddingRight: '5px' }}>Data Processing Agreement</Typography>
          </a>
          <Typography>and I accept.</Typography>
        </Box>
      </Stack>
    </Stack>
  );
}
